import { createNewNotebook, } from '@office-start/graph-service';
import { launchUrlWrapper } from './launchUrlWrapper';
import { showOneNoteDialog } from './NotebookDialogOperations';
export function launchOneNoteDialog(lastFocusedHtmlElement) {
    return new Promise(function (resolve) {
        function onClickResult(displayName, options) {
            createNewNotebook(options, displayName).then(function (url) {
                if (url) {
                    launchUrlWrapper(url).then(function (result) {
                        return resolve(result);
                    });
                }
                else {
                    return resolve({
                        type: "Error" /* CreateDocumentResultType.Error */,
                    });
                }
            });
        }
        showOneNoteDialog({
            onResult: onClickResult,
            lastFocusedHtmlElement: lastFocusedHtmlElement,
        });
        return;
    });
}
//# sourceMappingURL=launchOneNoteDialog.js.map